export default "__VITE_ASSET__17ec33fa__"